module.exports = __webpack_public_path__ + "static/media/收费站.11179c7e.svg";